module.exports = __webpack_public_path__ + "static/media/ico2.c116ad6b.png";